import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import {DetailList} from './components';
import Spinner from 'spinner';

import {loadInstitutionServiceDetail, cleanInstitutionPersonalDetails} from 'redux/actions/portal/institutions';

const mapStateToProps = (state) => ({
  detail: state.institutions.get('institutionServiceDetail'),
  isFetching: state.institutions.get('institutionsIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (service) => dispatch(loadInstitutionServiceDetail(service)),
  cleanDetails: () => dispatch(cleanInstitutionPersonalDetails())
});

class InstitutionServiceDetail extends Component {

  multilineStyle = {
    whiteSpace: 'pre-wrap',
    lineHeight: '1.3'
  }

  renderPaymentDetail = item => {
    if(!item.get('is_payment') || item.get('price') === 0){
      return <li><span>Ціна послуги: </span>безоплатна</li>
    } else {
      return <li><span>Ціна послуги: </span>{item.get('price')} грн.</li>
    }
  }

  renderServiceInfo = (key, stub = 'інформація відсутня') => {
    const keyToFind = typeof key === 'string' ? [key] : key
    let valueToRender = this.props.detail.getIn(keyToFind)
    if(typeof valueToRender === 'boolean') {
      return valueToRender ? 'Так' : 'Ні'
    }
    if(typeof valueToRender === 'string') valueToRender = valueToRender.trim()
    return valueToRender || stub
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.service);
  }

  componentWillUnmount () {
    this.props.cleanDetails()
  }

  render() {

    const item = this.props.detail;

    if (!this.props.detail) return null;

    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/institutions">Установи</Link></li>
          <li><Link to={`/institutions/detail/${item.getIn(['institution_data', 'id'])}`}>{item.getIn(['institution_data', 'short_title'])}</Link></li>
          <li><Link to={`/institutions/detail/${item.getIn(['institution_data', 'id'])}/services/${item.get('id')}`}>Послуга</Link></li>
        </Breadcrumbs>
        <Wrapper>
          {this.props.isFetching ? (
            <Spinner/>
          ):(
            <Grid>
              <h2 style={{marginBottom: "10px"}}>Послуга</h2>
              <DetailList>
                <li style={this.multilineStyle}><span>Назва послуги: </span>{this.renderServiceInfo(['service_data', 'title'])}</li>
                <li><span>Код: </span>{this.renderServiceInfo(['service_data', 'code'])}</li>
                {this.renderPaymentDetail(item)}
                <li><span>Номер кабінета: </span>{this.renderServiceInfo('cabinet_number')}</li>
                <li style={this.multilineStyle}><span>Розклад роботи: </span>{this.renderServiceInfo('schedule')}</li>
                <li><span>Телефон: </span>{this.renderServiceInfo('phone')}</li>
                <li style={this.multilineStyle}><span>Опис послуги: </span>{this.renderServiceInfo(['service_data', 'description'])}</li>
                <li style={this.multilineStyle}><span>Підготовка до отримання послуги: </span>
                  {this.renderServiceInfo('instruction', '') || this.renderServiceInfo(['service_data', 'instruction'])}
                  </li>
                <li style={this.multilineStyle}><span>Додаткові відомості та особливості: </span>
                  {this.renderServiceInfo('comment', '') || this.renderServiceInfo(['service_data', 'additional_info'])}
                  </li>
              </DetailList>
            </Grid>
          )}
        </Wrapper>
      </div>
    )
  }
}
InstitutionServiceDetail.propTypes = {
  detail: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionServiceDetail);



// WEBPACK FOOTER //
// ./src/system/main/institutions/service-detail.js